import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { History, HistoryApi } from "@front/m19-api-client";
import { IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-modal-activity-comment",
  templateUrl: "./modal-activity-comment.component.html",
  imports: [TranslocoDirective, FormsModule, IButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalActivityCommentComponent {
  private historyService = inject(HistoryApi);

  @Output() update: EventEmitter<string> = new EventEmitter();

  modalData = inject(MODAL_DATA) as ModalActivityCommentData;
  modalRef = inject(ModalRef);

  comment = "";

  constructor() {
    this.comment = this.modalData.history.comment ?? "";
  }

  deleteComment() {
    this.comment = "";
    this.save();
  }

  save() {
    this.historyService
      .updateHistory({
        accountId: this.modalData.history.accountId!,
        marketplace: this.modalData.history.marketplace!,
        id: this.modalData.history.id!,
        historyComment: { comment: this.comment },
      })
      .subscribe((res) => {
        if (res) {
          this.update.emit(this.comment);
        }
        this.modalRef.close(this.comment);
      });
  }
}

export interface ModalActivityCommentData {
  history: History;
}
